import React from 'react';
import { useTranslation } from 'react-i18next';
import { Greeting as GreetingShared } from '@cp-shared-19/frontend-ui';

export const Greeting: React.FC = () => {
    const { t } = useTranslation('greeting');

    return <GreetingShared fullGreetingText={t('headline')} />;
};
